export default __webpack_public_path__ + "static/media/IraLippkeStudios_Lina_Shteyn_BarDivEng-008.be8c298b.jpg";